export const DogSelector = {
  DogContainer: 'dog-container',
  DogCheckboxPrefix: 'dog-checkbox',
} as const;
